import React from 'react';
import { Link } from 'react-router-dom';

const Landing: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-900 via-secondary-800 to-accent-900">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-72 h-72 bg-primary-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float"></div>
          <div className="absolute top-40 right-20 w-96 h-96 bg-secondary-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float" style={{ animationDelay: '1s' }}></div>
          <div className="absolute bottom-20 left-1/3 w-80 h-80 bg-accent-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float" style={{ animationDelay: '2s' }}></div>
        </div>

        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 pt-16 sm:pt-24 pb-16 sm:pb-32">
          <div className="text-center animate-fade-in">
            <div className="mb-6 sm:mb-8">
              <span className="text-6xl sm:text-8xl md:text-9xl animate-bounce-slow inline-block">⚽</span>
            </div>
            <h1 className="text-4xl sm:text-6xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Vítejte v <span className="bg-gradient-to-r from-primary-300 via-secondary-300 to-accent-300 bg-clip-text text-transparent">Goalie</span>
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-primary-100 mb-8 sm:mb-12 max-w-3xl mx-auto px-4">
              Nejlepší systém pro správu stolního fotbálku. Rezervujte stoly, soupeřte s přáteli, sledujte statistiky a šplhejte v žebříčku!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center px-4">
              <Link
                to="/register"
                className="w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-primary-500 to-secondary-500 text-white text-lg sm:text-xl font-bold rounded-2xl shadow-glow hover:shadow-glow-lg transform hover:scale-105 transition-all duration-300"
              >
                Začít 🚀
              </Link>
              <Link
                to="/login"
                className="w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-white/10 backdrop-blur-sm text-white text-lg sm:text-xl font-bold rounded-2xl border-2 border-white/30 hover:bg-white/20 transform hover:scale-105 transition-all duration-300"
              >
                Přihlásit se
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="relative bg-white/5 backdrop-blur-sm py-12 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white text-center mb-8 sm:mb-16">
            Proč hráči milují Goalie
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 hover:bg-white/20 transform hover:scale-105 hover:shadow-card-hover transition-all duration-300 animate-slide-up">
              <div className="text-5xl sm:text-6xl mb-4 sm:mb-6">🎮</div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">Snadné rezervace</h3>
              <p className="text-primary-100 text-sm sm:text-base">
                Rezervujte stolní fotbálek během pár vteřin pomocí jednoduchých kódů. Žádné komplikace, jen hra!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 hover:bg-white/20 transform hover:scale-105 hover:shadow-card-hover transition-all duration-300 animate-slide-up" style={{ animationDelay: '0.1s' }}>
              <div className="text-5xl sm:text-6xl mb-4 sm:mb-6">📊</div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">Živé skóre</h3>
              <p className="text-primary-100 text-sm sm:text-base">
                Sledujte góly v reálném čase díky systému postavenému na WebSocketech. Každý zásah se počítá!
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 hover:bg-white/20 transform hover:scale-105 hover:shadow-card-hover transition-all duration-300 animate-slide-up" style={{ animationDelay: '0.2s' }}>
              <div className="text-5xl sm:text-6xl mb-4 sm:mb-6">🏆</div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">Žebříčky</h3>
              <p className="text-primary-100 text-sm sm:text-base">
                Bojujte o první místo! Uvidíte nejlepší hráče a svůj postup.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 hover:bg-white/20 transform hover:scale-105 hover:shadow-card-hover transition-all duration-300 animate-slide-up" style={{ animationDelay: '0.3s' }}>
              <div className="text-5xl sm:text-6xl mb-4 sm:mb-6">👥</div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4">Týmová hra</h3>
              <p className="text-primary-100 text-sm sm:text-base">
                Zakládejte týmy, hrajte s přáteli a ovládněte turnaje společně!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative py-12 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 text-center">
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 animate-fade-in">
              <div className="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">🧭</div>
              <div className="text-lg sm:text-xl text-white font-bold mb-2">Transparentní flow</div>
              <p className="text-primary-100 text-sm sm:text-base">Zřetelné kroky od přihlášení po start zápasu, žádné matoucí hlášky o ceně či počtu her.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 animate-fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">🛡️</div>
              <div className="text-lg sm:text-xl text-white font-bold mb-2">Fair play</div>
              <p className="text-primary-100 text-sm sm:text-base">Odehrajte jen to, co opravdu chcete – žádné balíčky ani sliby počtu her.</p>
            </div>
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-6 sm:p-8 border border-white/20 animate-fade-in" style={{ animationDelay: '0.4s' }}>
              <div className="text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-4">📈</div>
              <div className="text-lg sm:text-xl text-white font-bold mb-2">Reálné statistiky</div>
              <p className="text-primary-100 text-sm sm:text-base">Historie zápasů a žebříčky vycházejí z odehraných her, ne z marketingových čísel.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="relative py-12 sm:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            Připraveni ovládnout hru? 🎯
          </h2>
          <p className="text-lg sm:text-xl text-primary-100 mb-8 sm:mb-12 max-w-2xl mx-auto px-4">
            Přidejte se k tisícům hráčů bojujících o slávu. Vaše cesta na vrchol začíná právě zde!
          </p>
          <Link
            to="/register"
            className="inline-block px-10 sm:px-16 py-4 sm:py-6 bg-gradient-to-r from-secondary-500 to-accent-500 text-white text-lg sm:text-2xl font-bold rounded-2xl shadow-glow-lg hover:shadow-glow transform hover:scale-110 transition-all duration-300"
          >
            Začněte hrát hned
          </Link>
        </div>
      </div>

      <div className="relative border-t border-white/20 py-6 sm:py-8">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-primary-200 text-sm sm:text-base">
              © 2025 Goalie. Vytvořeno pro milovníky stolního fotbalu.
            </div>
            <div className="flex gap-4 sm:gap-6">
              <Link to="/leaderboard" className="text-primary-200 hover:text-white transition-colors text-sm sm:text-base">
                Žebříček
              </Link>
              <Link to="/login" className="text-primary-200 hover:text-white transition-colors text-sm sm:text-base">
                Přihlášení
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
